const state = {
  walletList: [],
  isLoading: false,
  isTransporterListLoading: false,
  transporterWallet: [],
  page: 1,
  hasEmpty: false,
};

export default state;
